(function (d, s, id) {
  var js, fjs = d.getElementsByTagName(s)[0];
  if (d.getElementById(id))return;
  js = d.createElement(s);
  js.id = id;
  js.src = "//connect.facebook.net/es_ES/sdk.js#xfbml=1&version=v2.0&&appId="+vocento.tracking.config.facebookAppId+"&status=true&cookie=true";
  fjs.parentNode.insertBefore(js, fjs);
}(document, 'script', 'facebook-jssdk'));



// WEBPACK FOOTER //
// ./src/tracking/facebook-root.js